export const TEXTS = {
  APP_INSTALL_MODAL_TITLE: 'Установите приложение',
  APP_INSTALL_MODAL_CONTENT:
    'Для стабильного проигрывания музыки — установите приложение. Если остаётесь в браузере — держите вкладку активной и не блокируйте экран телефона.',
  APP_INSTALL_MODAL_HELP_LINK: 'Какие плееры доступны и какой выбрать',
  APP_INSTALL_MODAL_CONFIRM: 'Установить мобильное приложение',
  APP_INSTALL_MODAL_CONTINUE: 'Продолжить слушать в веб плеере',
};
